import React from 'react';
import { FiChevronDown } from 'react-icons/fi';
import { FiFacebook, FiTwitter, FiInstagram, FiYoutube, FiMapPin, FiPhone, FiMail } from 'react-icons/fi';
import './BiographyPage.css';
import './ConstitutionPage.css';

const ConstitutionPage = ({ onBack, onNavigate }) => {
  const navigate = (target) => {
    if (onNavigate) onNavigate(target);
    else if (onBack) onBack();
  };

  return (
    <div className="cp-page">

      {/* Navbar */}
      <nav className="bio-navbar">
        <div className="bio-navbar-logo">
          <img src="/Sndp/logo.png" alt="Pravasi SNDP Yogam Logo" />
        </div>
        <div className="bio-navbar-links">
          <div className="bio-nav-menu">
            <a href="#home" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('home'); }}>Home</a>
            <div className="bio-nav-about-wrapper">
              <span className="bio-nav-link bio-nav-dropdown">
                About <FiChevronDown size={14} />
              </span>
              <div className="bio-nav-about-dropdown">
                <button onClick={() => navigate('ourhistory')}>Our History</button>
                <button onClick={() => navigate('leadership')}>Leadership</button>
              </div>
            </div>
            <a href="#gallery" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('gallery'); }}>Gallery</a>
            <a href="#news" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('news'); }}>News &amp; Articles</a>
            <a href="#eventcalendar" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('eventcalendar'); }}>Event Calendar</a>
            <a href="#constitution" className="bio-nav-link" style={{ fontWeight: 700, color: '#000000' }}>Constitution</a>
            <a href="#membership" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('membership'); }}>Membership</a>
            <a href="#contact" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('contact'); }}>Contact Us</a>
          </div>
          <a href="#donate" className="bio-donate-btn">Donation</a>
        </div>
      </nav>

      {/* Title Section */}
      <div className="cp-title-section">
        <h1>Constitution</h1>
        <div className="cp-title-bar"></div>
      </div>

      {/* Main Card */}
      <div className="cp-card">
        <div className="cp-text">

          <p className="cp-main-title">
            CONSTITUTION OF PRAVASI SNDP YOGAM FAMILY UNIT<br />
            <span style={{ fontSize: '17px', fontWeight: 600 }}>(പ്രവാസി SNDP യോഗം കുടുംബയോഗം ഭരണഘടന)</span>
          </p>

          <hr className="cp-divider" />

          {/* Section 1 */}
          <p className="cp-section-title">1. Name (പേര്)</p>
          <p>
            <strong>1.1</strong> The name of the unit shall be Pravasi SNDP Yogam UK Unit Number —, Kudumba Yogam.
          </p>
          <p style={{ fontWeight: 400, fontSize: '15px', color: '#555' }}>
            (കുടുംബയോഗത്തിന്റെ പേര് പ്രവാസി SNDP യോഗം UK യൂണിറ്റ് നമ്പർ —, കുടുംബയോഗം ആയിരിക്കും.)
          </p>

          <hr className="cp-divider" />

          {/* Section 2 */}
          <p className="cp-section-title">2. Objectives (ലക്ഷ്യങ്ങൾ)</p>
          <p><strong>2.1</strong> The objectives of the Family Unit shall be:</p>
          <p style={{ fontWeight: 400, fontSize: '15px', color: '#555' }}>(കുടുംബയോഗത്തിന്റെ പ്രധാന ലക്ഷ്യങ്ങൾ:)</p>
          <ul>
            <li>
              To promote unity, peace, and social welfare among members.
              <br /><span style={{ fontWeight: 400, fontSize: '15px', color: '#555' }}>(അംഗങ്ങൾക്കിടയിൽ ഐക്യവും സമാധാനവും സാമൂഹ്യക്ഷേമവും പ്രോത്സാഹിപ്പിക്കുക.)</span>
            </li>
            <li>
              To practice and propagate the teachings of Sree Narayana Guru.
              <br /><span style={{ fontWeight: 400, fontSize: '15px', color: '#555' }}>(ശ്രീനാരായണ ഗുരുവിന്റെ ഉപദേശങ്ങൾ പ്രചരിപ്പിക്കുകയും പാലിക്കുകയും ചെയ്യുക.)</span>
            </li>
            <li>
              To foster spiritual, cultural, and family welfare programs.
              <br /><span style={{ fontWeight: 400, fontSize: '15px', color: '#555' }}>(ആത്മീയ, സാംസ്കാരിക, കുടുംബക്ഷേമ പ്രവർത്തനങ്ങൾ നടത്തുക.)</span>
            </li>
            <li>
              To accept and implement the decisions made by higher bodies like Pravasi SNDP Yogam UK and Regional Coordination Council (RCC).
              <br /><span style={{ fontWeight: 400, fontSize: '15px', color: '#555' }}>(മേൽഘടകമായ പ്രവാസി SNDP യോഗം UK, RCC എന്നിവയുടെ തീരുമാനങ്ങൾ അംഗീകരിച്ചു നടപ്പിലാക്കുക.)</span>
            </li>
          </ul>

          <hr className="cp-divider" />

          {/* Section 3 */}
          <p className="cp-section-title">3. Membership (അംഗത്വം)</p>

          <p className="cp-subsection-title">3.1 Family Membership (കുടുംബ അംഗത്വം)</p>
          <ul>
            <li>
              Any family that believes in the teachings of Sree Narayana Guru and supports the objectives of the organization can obtain membership.
              <br /><span style={{ fontWeight: 400, fontSize: '15px', color: '#555' }}>(ശ്രീനാരായണ ഗുരുവിന്റെ ദർശനത്തിൽ വിശ്വസിക്കുകയും സംഘടനയുടെ ലക്ഷ്യങ്ങളെ പിന്തുണക്കുകയും ചെയ്യുന്ന കുടുംബങ്ങൾക്ക് അംഗത്വം ലഭിക്കും.)</span>
            </li>
          </ul>

          <p className="cp-subsection-title">3.2 Permanent Membership (സ്ഥിരാംഗത്വം)</p>
          <ul>
            <li>
              Families who actively participate in the unit's activities for at least one year shall be eligible for permanent membership.
              <br /><span style={{ fontWeight: 400, fontSize: '15px', color: '#555' }}>(ഒരു വർഷം യൂണിറ്റിന്റെ പ്രവർത്തനങ്ങളിൽ സ്ഥിരമായി പങ്കെടുക്കുന്ന കുടുംബങ്ങൾക്ക് സ്ഥിരാംഗത്വം ലഭിക്കും.)</span>
            </li>
            <li>
              Any individual from a registered family who has paid the permanent membership fee shall automatically become a permanent member upon reaching the age of 18.
              <br /><span style={{ fontWeight: 400, fontSize: '15px', color: '#555' }}>(സ്ഥിരാംഗത്വ ഫീസ് അടച്ച് രജിസ്റ്റർ ചെയ്ത കുടുംബത്തിലെ 18 വയസ്സ് തികഞ്ഞ ഏതൊരാളും സ്വമേധയാ സ്ഥിരാംഗമായി പരിഗണിക്കപ്പെടും.)</span>
            </li>
          </ul>

          <hr className="cp-divider" />

          {/* Section 4 */}
          <p className="cp-section-title">4. Structure and Governance (ഘടനയും ഭരണസംവിധാനവും)</p>
          <p>
            <strong>4.1</strong> The Family Unit shall have the following Office Bearers for a term of 3 years:
          </p>
          <p style={{ fontWeight: 400, fontSize: '15px', color: '#555' }}>
            (കുടുംബയോഗത്തിൽ 3 വർഷം കാലാവധിയുള്ള താഴെപ്പറയുന്ന ഭാരവാഹികൾ ഉണ്ടായിരിക്കും.)
          </p>
          <ul>
            <li>President (പ്രസിഡന്റ്)</li>
            <li>Vice President (വൈസ് പ്രസിഡണ്ട്)</li>
            <li>Secretary (സെക്രട്ടറി)</li>
            <li>Treasurer (ട്രഷറർ)</li>
            <li>6 Executive Committee Members (6 എക്സിക്യൂട്ടീവ് അംഗങ്ങൾ)</li>
            <li>1 RCC Member (1 RCC അംഗം)</li>
          </ul>
          <p>
            <strong>4.2</strong> At least 3 women members must be part of the Executive Committee, and at least one woman must hold any of the four key positions: President, Vice President, Secretary, or Treasurer.
          </p>
          <p style={{ fontWeight: 400, fontSize: '15px', color: '#555' }}>
            (ഭരണ സമിതിയിൽ കുറഞ്ഞത് 3 വനിത അംഗങ്ങൾ ഉണ്ടായിരിക്കണം. പ്രസിഡണ്ട്, വൈസ് പ്രസിഡണ്ട്, സെക്രട്ടറി, ട്രഷറർ എന്നീ നാല് പ്രധാനസ്ഥാനങ്ങളിൽ ഒരു വനിത നിർബന്ധമാണ്.)
          </p>

          <hr className="cp-divider" />

          {/* Section 5 */}
          <p className="cp-section-title">5. Election Process (തെരഞ്ഞെടുപ്പ് പ്രക്രിയ)</p>
          <p>
            <strong>5.1</strong> Elections for Office Bearers shall be conducted at the Annual General Meeting (AGM) or a Special General Meeting convened for that purpose.
          </p>
          <p style={{ fontWeight: 400, fontSize: '15px', color: '#555' }}>
            (വാർഷിക പൊതുയോഗം (AGM) അല്ലെങ്കിൽ പ്രത്യേക പൊതുയോഗം വഴി ഭാരവാഹികളെ തെരഞ്ഞെടുക്കണം.)
          </p>
          <p><strong>5.2</strong> Elections shall be held once every 3 years.</p>
          <p style={{ fontWeight: 400, fontSize: '15px', color: '#555' }}>(3 വർഷം കൂടുമ്പോൾ തെരഞ്ഞെടുപ്പ് നടത്തണം.)</p>
          <p><strong>5.3</strong> All members with permanent membership shall have the right to vote.</p>
          <p style={{ fontWeight: 400, fontSize: '15px', color: '#555' }}>
            (സ്ഥിരാംഗത്വമുള്ള എല്ലാ അംഗങ്ങൾക്കും വോട്ട് ചെയ്യാനുള്ള അവകാശം ഉണ്ടായിരിക്കും.)
          </p>

          <hr className="cp-divider" />

          {/* Section 6 */}
          <p className="cp-section-title">6. Finance &amp; Accounts (സാമ്പത്തിക കാര്യങ്ങൾ)</p>
          <p><strong>6.1</strong> The Organization shall maintain a transparent and accountable financial system.</p>
          <p><strong>6.2</strong> Sources of Income (സാമ്പത്തിക സ്രോതസ്സുകൾ)</p>
          <ul>
            <li>Registration Fee: £15 (one-time payment)</li>
            <li>Unit Registration Fee: £10 (one-time payment)</li>
            <li>Permanent Membership Fee: £5 per person above 18 years old</li>
            <li>Monthly Subscription: £5 per family (£3 to Unit Fund, £2 to Yogam Fund)</li>
            <li>Donations: Collected as per General Body decisions for special events and charity.</li>
          </ul>
          <p>
            <strong>6.3</strong> The Treasurer shall handle financial records and transactions responsibly.
          </p>
          <p style={{ fontWeight: 400, fontSize: '15px', color: '#555' }}>
            (ട്രഷറർ സാമ്പത്തിക രേഖകളും ഇടപാടുകളും സൂക്ഷിച്ച് നിയന്ത്രിക്കണം.)
          </p>
          <p><strong>6.4</strong> Transactions exceeding £500 shall require Executive Committee approval.</p>
          <p style={{ fontWeight: 400, fontSize: '15px', color: '#555' }}>
            (£500 നു മുകളിൽ ഇടപാടുകൾക്ക് എക്സിക്യൂട്ടീവ് കമ്മിറ്റിയുടെ അനുമതി ആവശ്യമാണ്.)
          </p>
          <p><strong>6.5</strong> All major financial transactions must be approved and signed by the President and Secretary.</p>
          <p style={{ fontWeight: 400, fontSize: '15px', color: '#555' }}>
            (പ്രസിഡന്റും സെക്രട്ടറിയും ഒപ്പുവെച്ച് പ്രധാന സാമ്പത്തിക ഇടപാടുകൾ നടത്തണം.)
          </p>

          <hr className="cp-divider" />

          {/* Section 7 */}
          <p className="cp-section-title">7. Meetings (യോഗങ്ങൾ)</p>
          <p><strong>7.1</strong> Monthly Family Meetings shall be conducted to ensure active participation of all members.</p>
          <p style={{ fontWeight: 400, fontSize: '15px', color: '#555' }}>
            (മാസത്തിൽ ഒരിക്കൽ കുടുംബയോഗം സംഘടിപ്പിച്ച് അംഗങ്ങളുടെ സജീവ പങ്കാളിത്തം ഉറപ്പാക്കണം.)
          </p>
          <p><strong>7.2</strong> Annual General Meeting (AGM) shall be conducted once a year.</p>
          <p style={{ fontWeight: 400, fontSize: '15px', color: '#555' }}>(വാർഷിക പൊതുയോഗം വർഷത്തിൽ ഒരിക്കൽ നടത്തണം.)</p>
          <p><strong>7.3</strong> Special General Meetings (SGM) can be called when necessary.</p>
          <p style={{ fontWeight: 400, fontSize: '15px', color: '#555' }}>(ആവശ്യമായാൽ പ്രത്യേക പൊതുയോഗം വിളിക്കാം.)</p>

          <hr className="cp-divider" />

          {/* Section 8 */}
          <p className="cp-section-title">8. Amendments &amp; Dissolution (ഭരണഘടന ഭേദഗതികളും പിരിച്ചുവിടലും)</p>
          <p>
            All decisions regarding amendments and dissolution shall be vested with the higher body.
          </p>
          <p style={{ fontWeight: 400, fontSize: '15px', color: '#555' }}>
            (ഭരണഘടനാ ഭേദഗതികളും യൂണിറ്റിന്റെ പിരിച്ചുവിടലും മേൽഘടക തീരുമാനത്തിന് വിധേയമായിരിക്കും.)
          </p>

          <hr className="cp-divider" />

          <p className="cp-closing">
            This Constitution was adopted on [Date] and shall remain effective until amended.<br />
            <span style={{ fontWeight: 400, fontSize: '14px', color: '#777' }}>
              (ഈ ഭരണഘടന [തീയതി] ന് അംഗീകരിച്ചു ഭേദഗതി വരുത്തുന്നത് വരെ പ്രാബല്യത്തിൽ തുടരും.)
            </span>
          </p>

        </div>
      </div>

      {/* Footer */}
      <footer className="bio-footer">
        <div className="bio-footer-main">
          <div className="bio-footer-brand">
            <div className="bio-footer-logo-row">
              <img src="/Sndp/logo.png" alt="Logo" className="bio-footer-logo-img" />
              <div className="bio-footer-brand-info">
                <h3 className="bio-footer-brand-name">Pravasi SNDP Yogam, UK Bristol</h3>
                <p className="bio-footer-brand-desc">
                  We, Pravasi SNDP Yogam members, are the devotees of Sree Narayana Guru,
                  a revered saint and social reformer from Kerala, India (1854-1928).
                </p>
                <div className="bio-footer-socials">
                  <a href="#facebook" aria-label="Facebook"><FiFacebook size={20} color="#FFC501" /></a>
                  <a href="#twitter" aria-label="Twitter"><FiTwitter size={20} color="#FFC501" /></a>
                  <a href="#instagram" aria-label="Instagram"><FiInstagram size={20} color="#FFC501" /></a>
                  <a href="#youtube" aria-label="YouTube"><FiYoutube size={28} color="#FFC501" /></a>
                </div>
              </div>
            </div>
          </div>

          <div className="bio-footer-contact">
            <h4 className="bio-footer-column-title">Contact Us</h4>
            <div className="bio-footer-contact-list">
              <div className="bio-footer-contact-item">
                <FiMapPin size={20} color="#FFC501" />
                <span>Almondsbury Creative 10 Gloucester Road, Bristol</span>
              </div>
              <div className="bio-footer-contact-item">
                <FiPhone size={20} color="#FFC501" />
                <span>+91 84524145547</span>
              </div>
              <div className="bio-footer-contact-item">
                <FiMail size={20} color="#FFC501" />
                <span>sndpyogamuk@gmail.com</span>
              </div>
            </div>
          </div>

          <div className="bio-footer-links">
            <h4 className="bio-footer-column-title">Quick Links</h4>
            <ul className="bio-footer-nav">
              <li><a href="#home" onClick={onBack}>Home</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#history">History</a></li>
              <li><a href="#organization">Organization</a></li>
              <li><a href="#sree-narayana-guru">Sree Narayana Guru</a></li>
              <li><a href="#articles">Articles</a></li>
              <li><a href="#gallery" onClick={(e) => { e.preventDefault(); navigate('gallery'); }}>Gallery</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>

          <div className="bio-footer-newsletter">
            <h4 className="bio-footer-column-title">Newsletter</h4>
            <p className="bio-newsletter-desc">Subscribe to our Newsletter</p>
            <div className="bio-newsletter-form">
              <input type="email" placeholder="Enter your email" />
              <button type="button">Subscribe</button>
            </div>
          </div>
        </div>

        <div className="bio-footer-bottom">
          <span>© 2025 Pravasi SNDP Yogam. All rights reserved.</span>
          <div className="bio-footer-bottom-links">
            <a href="#terms">Terms of Use</a>
            <a href="#privacy">Privacy Policy</a>
          </div>
        </div>
      </footer>

    </div>
  );
};

export default ConstitutionPage;
